import { type ButtonHTMLAttributes } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
}

export function CTAButton({ label, ...rest }: Props) {
  return (
    <button {...rest} className={`lume-cta ${rest.className ?? ''}`}>
      {label}
    </button>
  );
}
